export default "/_next/static/images/ARView-c5718315241c2631475e77446d5d719c.png";